<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const { accountId } = useAccount();

const stayUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/stay/calendar`
);
</script>

<template>
  <div class="w-full h-full">
    <NervenetFrame :src="stayUrl" />
  </div>
</template>
